import { Injectable } from '@angular/core';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';
import { ICostUnitGroup } from '../models/cost-unit-group.model';
import { ICostUnitGroupOverview } from '../models/cost-unit-group-overview.model';
import { IContributionMarginLevel } from '../models/contribution-margin-level.model';
import { ICostUnit } from '../models/cost-unit.model';

const BASE_URL: string = 'cost-unit-group';

@Injectable({
    providedIn: 'root',
})
export class CostUnitGroupResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getAllCostUnitGroups(): Observable<ICostUnitGroupOverview[]> {
        return this.myCostAccountingRequestService.get(BASE_URL);
    }

    public createCostUnitGroup(costUnit: ICostUnitGroup): Observable<ICostUnitGroup> {
        return this.myCostAccountingRequestService.post(BASE_URL, costUnit);
    }

    public updateCostUnitGroup(costUnit: ICostUnitGroup): Observable<ICostUnitGroup> {
        return this.myCostAccountingRequestService.put(`${BASE_URL}/${costUnit.id}`, costUnit);
    }

    public deleteCostUnitGroup(costUnitGroupId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${costUnitGroupId}`);
    }

    public getAssignedContributionMarginLevelsForGroup(costUnitGroupId: number): Observable<IContributionMarginLevel[]> {
        return this.myCostAccountingRequestService.get(`${BASE_URL}/${costUnitGroupId}/contribution-margin-levels`);
    }

    public assignContributionMarginLevelToGroup(costUnitGroupId: number, contributionMarginLevelId: number): Observable<void> {
        return this.myCostAccountingRequestService.post(`${BASE_URL}/${costUnitGroupId}/contribution-margin-levels`, { contributionMarginLevelId });
    }

    public unassignContributionMarginLevel(costUnitGroupId: number, contributionMarginLevelId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(
            `${BASE_URL}/${costUnitGroupId}/contribution-margin-levels/${contributionMarginLevelId}`);
    }

    public getAssignedCostUnitsForGroup(costUnitGroupId: number): Observable<ICostUnit[]> {
        return this.myCostAccountingRequestService.get(`${BASE_URL}/${costUnitGroupId}/cost-units`);
    }

    public assignCostUnitToGroup(costUnitGroupId: number, costUnitIds: number[]): Observable<void> {
        return this.myCostAccountingRequestService.post(`${BASE_URL}/${costUnitGroupId}/cost-units`, {  costUnitIds });
    }

    public removeCostUnitAssignment(costUnitGroupId: number, costUnitId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${costUnitGroupId}/cost-units/${costUnitId}`);
    }
}
